import { render } from "./StateBudgetIndicatorForm.vue?vue&type=template&id=244ecfca"
import script from "./StateBudgetIndicatorForm.vue?vue&type=script&lang=js"
export * from "./StateBudgetIndicatorForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__